export enum AccountIntegrations {
    LinkedIn = 'LinkedIn'
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/enums/accountIntegrations.ts